import { render } from "./ProductInfoTab.vue?vue&type=template&id=d4cb950e"
import script from "./ProductInfoTab.vue?vue&type=script&lang=js"
export * from "./ProductInfoTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Products/ProductInfoTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d4cb950e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d4cb950e', __exports__)) {
    api.reload('d4cb950e', __exports__)
  }
  
  module.hot.accept("./ProductInfoTab.vue?vue&type=template&id=d4cb950e", () => {
    api.rerender('d4cb950e', render)
  })

}


export default __exports__